import { createFileRoute } from '@tanstack/react-router'

import { MedicationPaymentSuccess } from '~/features/dashboard/pages/medicals/components/medication-success'
import { MedicationConfirmationSearchParams } from '~/features/dashboard/pages/medicals/schemas';

export const Route = createFileRoute(
    '/(dashboard)/dashboard/weight-loss/medicals/confirmation',
)({
    component: () => (
        <main
            role="main"
            aria-label="medicals"
            className="min-h-screen w-full px-4 sm:px-[32px] lg:px-[200px]"
        >
            <div className="flex flex-col gap-4 mt-10">
                <MedicationPaymentSuccess />
            </div>
        </main>
    ),
    validateSearch: (search: Record<string, unknown>): MedicationConfirmationSearchParams => {
        return {
            prescription_id: search.prescription_id as string | undefined,
        };
    },
    errorComponent: ({ error }: { error: Error }) => (
        <div
            role="alert"
            className="flex min-h-screen items-center justify-center p-4"
        >
            <div className="text-center">
                <h1 className="text-2xl font-bold">Error Loading Medication payment success</h1>
                <pre className="mt-4">{error.message}</pre>
            </div>
        </div>
    ),
})


